import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { ProductInterface } from './type';
import { ProductRepository } from './repository';
import { useCategories } from '@/features/categories/controller';
import { useRoute } from 'vue-router';
import { useUsers } from '@/features/users/controller'

export const useProducts = defineStore('products', () => {

    const $userStore = useUsers()
    const productRepository = new ProductRepository();
    const activeProduct = ref<ProductInterface | null>(null)
    const $categoriesStore = useCategories();
    const route = useRoute();

    const getProduct = async (id: number) => {
        
        let userId = null
        if ($userStore.selectedUserForShop && $userStore.loggedUser && ($userStore.loggedUser.type === 'administrator' || $userStore.loggedUser.type === 'storekeeper') && typeof $userStore.selectedUserForShop === 'object') {
            userId = $userStore.selectedUserForShop.id
        } else if ($userStore.loggedUser) {
            userId = $userStore.loggedUser.id
        }

        const res = await productRepository.getProduct(id, { userId })
        if (!res.error) {
            activeProduct.value = res.data.product
        }
        return res
    }

    const getProductsByIds = async (ids: number[]) => {  
        let userId = null
        if ($userStore.selectedUserForShop && $userStore.loggedUser && ($userStore.loggedUser.type === 'administrator' || $userStore.loggedUser.type === 'storekeeper') && typeof $userStore.selectedUserForShop === 'object') {
            userId = $userStore.selectedUserForShop.id
        } else if ($userStore.loggedUser) {
            userId = $userStore.loggedUser.id
        }
        const res = await productRepository.getProductsByIds({ids : ids, userId })
        return res
    }


    const searchQuery = ref('');
    const searchResults = ref<any[]>([]);
    const searchLoading = ref(false);
    let searchTimeout: number | null = null;

    const onSearchInput = async (categoryId: string | null = null, page: number, perPage: number = 12, parentId?: number | null) => {
        if (searchTimeout) clearTimeout(searchTimeout);
        if (!searchQuery.value.trim()) {
            searchResults.value = [];
            searchLoading.value = false;
            return;
        }
        searchLoading.value = true;
        searchTimeout = window.setTimeout(async () => {
            const res = await searchProducts(searchQuery.value, categoryId, page, perPage, parentId);

            if (res.error) {
                searchResults.value = [];
            }

            $categoriesStore.productPagination = {
                currentPage: res.data.products.current_page,
                lastPage: res.data.products.last_page,
                perPage: res.data.products.per_page,
                total: res.data.products.total,
                from: res.data.products.from,
                to: res.data.products.to
            };

            searchResults.value = res?.data?.products.data || [];
            searchLoading.value = false;
        }, 400);
    };

    const searchProducts = async (query: string, categoryId : string |null, page: number, perPage: number = 12, parentId?: number | null) => {
        const res = await productRepository.searchProducts({ query: query, categoryId: categoryId, page, perPage, parentId });
        return res
    }

    const clearSearch = () => {
        searchQuery.value = '';
        searchResults.value = [];
    };

    return {
        activeProduct,
        getProduct,
        getProductsByIds,
        searchProducts,

        searchQuery,
        searchResults,
        searchLoading,
        onSearchInput,
        clearSearch,
    }

}, {
    persist: {
        paths: [],
    },
})
